
import { DashboardQuickAddButton } from "@/utils/dashboard/dashboard-quick-add-button";
import Vue from "vue";
import AppQuickAddButton from "./QuickAddButton.vue";
import AppQuickAddButtonAddModal from "./QuickAddButtonAddModal.vue";

export default Vue.extend({
	data(){
		return {
			addModalOpen: false
		};
	},
	props: {
		buttons: {
			type: Array as ()=>DashboardQuickAddButton[],
			required: true
		},
		editMode: Boolean,
		canEdit: Boolean
	},
	computed: {
		editModeOpen():boolean{
			return this.editMode && this.canEdit;
		}
	},
	methods: {
		addButtonClicked(){
			this.addModalOpen = true;
		},
		addButton(button:DashboardQuickAddButton){
			this.buttons.push(button);
		},
		removeButton(i:number){
			this.buttons.splice(i, 1);
		},
	},
	components: {
		AppQuickAddButton,
		AppQuickAddButtonAddModal
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	},
});
